/** @format */

import React from 'react'

import styles from './Vacancies.module.scss'

export const Vacancies = () => {
  return (
    <div className={styles.wrapper}>
      Vacancies
      <div>
        qui quibusdam sequi voluptas? Aliquid amet animi aut autem corporis,
        dolorum eius facere fuga fugit id in incidunt minima molestias nemo,
        placeat porro provident quasi quisquam quos repellat reprehenderit
        tempore
      </div>
    </div>
  )
}
